import { RouteObject } from 'react-router-dom';

import { AuthRoot } from '@/shared/app/auth/auth-root';
import { FullscreenLoader } from '@/shared/components/ui/fullscreen-loader/fullscreen-loader';

const sdaOnboardingRoutes: RouteObject = {
  path: '/onboarding',
  hydrateFallbackElement: <FullscreenLoader />,
  element: <AuthRoot />,
  children: [
    {
      index: true,
      lazy: async () => {
        const { OnboardingRootRoute } = await import('./onboarding-root');
        return { Component: OnboardingRootRoute };
      },
    },
    {
      path: 'confirmation',
      lazy: async () => {
        const { OnboardingConfirmationRoute } =
          await import('./onboarding-confirmation');
        return { Component: OnboardingConfirmationRoute };
      },
    },
  ],
};

const resellerName = import.meta.env.VITE_APP_SUPER_TENANT?.toLowerCase();

export const onboardingRoutes: RouteObject =
  resellerName === 'sda' ? sdaOnboardingRoutes : {};
